import React from "react";
import styles from "./Skeleton.module.css";

export function SkeletonTable() {
  // Show 5 skeleton rows to match typical table height
  return (
    <div className={styles.skeletonTable}>
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className={styles.skeletonTableRow}>
          <div className={styles.skeletonTableCellLarge} />
          <div className={styles.skeletonTableCellMedium} />
          <div className={styles.skeletonTableCellSmall} />
        </div>
      ))}
    </div>
  );
}
